import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const compareResultSchema = z.object({
  pValue: z.number(),
  percentageImprovement: z.number().nullable(),
  improvementDirection: z.enum(["better", "worse", "comparable"]),
});

const armSummarySchema = z.object({
  arm: z.enum(["treatment", "holdout"]),
  customers: z.number().int().nonnegative(),
  exposures: z.number().int().nonnegative(),
  customersWhoReplied: z.number().int().nonnegative(),
  customersWhoOrdered: z.number().int().nonnegative(),
  replyRate: z.number(),
  orderRate: z.number(),
  revenuePerCustomer: z.number(),
  revenuePerCustomerStdDev: z.number(),
  totalRevenue: z.number(),
});
export type ShopperAgentArmSummary = z.infer<typeof armSummarySchema>;

const splitMetadataSchema = z.object({
  splitId: zExt.objectId(),
  splitName: z.string(),
  teamId: zExt.objectId(),
  active: z.boolean(),
  startDate: z.date(),
  endDate: z.date().nullable(),
  attributionWindowDays: z.number().int().positive(),
  treatmentBuckets: z.array(z.number().int().min(0).max(999)),
});

export const getShopperAgentSplitAnalytics = {
  name: "getShopperAgentSplitAnalytics" as const,
  input: z.object({ splitId: zExt.objectId() }),
  output: z
    .object({
      split: splitMetadataSchema,
      treatment: armSummarySchema,
      holdout: armSummarySchema,
      replyRateSignificance: compareResultSchema,
      orderRateSignificance: compareResultSchema,
      revenuePerCustomerSignificance: compareResultSchema,
    })
    .nullable(),
};
